<script setup lang="ts">
import type { IconCopyProps } from '../composables/icon-copy.hook'

import { AppTooltip } from '@shared/ui/tooltips'

import { useIconCopy } from '../composables/icon-copy.hook'
import { AppIcon } from '../../app-icon'

defineOptions({
  name: 'IconCopy',
})

const props = withDefaults(defineProps<IconCopyProps>(), {
  tooltip: 'Copy',
})

const {
  icon,
  color,
  tooltipText,
  setCopy,
} = useIconCopy(props)
</script>

<template>
  <AppTooltip
    :text="tooltipText"
    size="small"
    placement="top"
  >
    <AppIcon
      :icon="icon"
      :color="color"
      @click="setCopy"
    />
  </AppTooltip>
</template>
